import customFieldsConstants from '../constants/CustomFieldsConstants';
import themeServices from '../themes/ThemeServices';

const customFieldsService = {
    getCustomFieldValue(customFields, name) {
        if (!Array.isArray(customFields)) {
            return undefined;
        }

        const customField = customFields.find((item) => {
            return item.name === name;
        });

        if (customField) {
            if (customField.value.length === 1) {
                return customField.value[0] || undefined;
            }
            return customField.value || undefined;
        }

        return undefined;
    },

    getCustomFieldValueWithBlanks(customFields, name) {
        const value = this.getCustomFieldValue(customFields, name);
        return this.isInvalidForBlank(value) ? customFieldsConstants.BLANK : value;
    },

    isInvalidForBlank(customField) {
        return !customField || customField === '' || customField === undefined;
    },

    isItemType(question, itemType) {
        return (
            customFieldsService.getCustomFieldValue(
                question.customFields,
                customFieldsConstants.ITEM_TYPE
            ) === itemType
        );
    },

    isItemSubType(question, itemSubType) {
        return (
            customFieldsService.getCustomFieldValue(
                question.customFields,
                customFieldsConstants.ITEM_SUB_TYPE
            ) === itemSubType
        );
    },

    isComponent(question, component) {
        return (
            customFieldsService.getCustomFieldValue(
                question.customFields,
                customFieldsConstants.COMPONENT
            ) === component
        );
    },

    isCompulsory(section) {
        return customFieldsService.getCustomFieldValue(section.customFields,
            customFieldsConstants.SPEAKING_TYPE) === customFieldsConstants.ITEM_COMPULSORY;
    },

    isListeningComponent(question) {
        return this.getFocusLevelCustomField(question.customFields) === customFieldsConstants.TEST_TYPE_LISTENING;
    },

    isMatching(question) {
        return this.isItemType(question, customFieldsConstants.ITEM_MATCHING);
    },

    isMatchingFeature(question) {
        return this.isItemType(question, customFieldsConstants.ITEM_MATCHING_FEATURES);
    },

    isMatchingHeadings(question) {
        return this.isItemType(question, customFieldsConstants.ITEM_MATCHING_HEADING);
    },

    isMPCMultiAnswer(question) {
        return this.isItemType(question, customFieldsConstants.ITEM_MULTI_ANSWER);
    },

    isFlowChartCompletionObjective(question) {
        return this.isItemType(question, customFieldsConstants.ITEM_FLOW_CHART_COMPLETION_OBJECTIVE);
    },

    isMatchingSentenceEnding(question) {
        return this.isItemType(question, customFieldsConstants.ITEM_MATCHING_SENTENCE_ENDING);
    },

    isMatching1(question) {
        return (
            this.isMatching(question)
            && this.isItemSubType(question, customFieldsConstants.ITEM_MATCHING_1)
        );
    },

    isMatching2(question) {
        return (
            this.isMatching(question)
            && this.isItemSubType(question, customFieldsConstants.ITEM_MATCHING_2)
        );
    },

    isMatchingInformation(question) {
        return this.isItemType(question, customFieldsConstants.ITEM_MATCHING_INFORMATION);
    },

    isMatchingPlanMapDiagramLabelling(question) {
        return this.isItemType(question, customFieldsConstants.ITEM_MATCHING_PLAN_MAP_DIAGRAM_LABELLING);
    },

    isSummaryCompletionObjective(question) {
        return this.isItemType(question, customFieldsConstants.ITEM_SUMMARY_COMPLETION_OBJECTIVE);
    },

    isSummaryCompletionProductive(question) {
        return this.isItemType(question, customFieldsConstants.ITEM_SUMMARY_COMPLETION_PRODUCTIVE);
    },

    isShortAnswerQuestion(question) {
        return this.isItemType(question, customFieldsConstants.ITEM_SHORT_ANSWER_QUESTIONS);
    },

    getFocusLevelCustomField(customFields) {
        const property = themeServices.isCeq()
            ? customFieldsConstants.TESTING_FOCUS_LEVEL_1_CEQ
            : customFieldsConstants.TESTING_FOCUS_LEVEL_1_FJORD;

        return this.getCustomFieldValue(customFields, property);
    },

    isWriting(question) {
        return this.getFocusLevelCustomField(question.customFields) === customFieldsConstants.TEST_TYPE_WRITING;
    },

    isSpeaking(question) {
        return this.getFocusLevelCustomField(question.customFields) === customFieldsConstants.TEST_TYPE_SPEAKING;
    },

    isReading(question) {
        return this.getFocusLevelCustomField(question.customFields) === customFieldsConstants.TEST_TYPE_READING;
    },
    getSuffix(captionProperties, isPaperBased) {
        let singularSuffix = '';

        const isListening = captionProperties.testingFocusLevel1 === customFieldsConstants.TEST_TYPE_LISTENING.toLowerCase();
        const isReading = captionProperties.testingFocusLevel1 === customFieldsConstants.TEST_TYPE_READING.toLowerCase();

        // Should apply in CD & PB for listening and Reading
        const isShortAnswerQuestionsSingular = captionProperties.itemType === customFieldsConstants.itemTypes.SHORT_ANSWER_QUESTIONS
            && (isListening || isReading);
        // Should apply in CD for Listening
        // Should apply in CD and PB for Reading
        const isMCQuestionSingular = captionProperties.itemType === customFieldsConstants.itemTypes.MC_QUESTIONS
            && ((isListening && !isPaperBased) || isReading);

        if (
            captionProperties.questionsCount === 1 &&
            (isShortAnswerQuestionsSingular || isMCQuestionSingular)
        ) {
            singularSuffix = '_singular';
        }

        return singularSuffix;
    },
};

export default customFieldsService;
